import React from 'react';

const Favorites = () => {
  return (
    <div>
      <h1>Favorite Cards</h1>
    </div>
  )
}

export default Favorites;
